import { useLocation, useRouter } from "@tanstack/react-router";
import { useCallback, useEffect, useState } from "react";

interface NavigationHistoryState {
  canGoBack: boolean;
  canGoForward: boolean;
  currentPath: string;
  goBack: () => void;
  goForward: () => void;
}

export const useNavigationHistory = (): NavigationHistoryState => {
  const router = useRouter();
  const location = useLocation();
  const [hasNavigatedInApp, setHasNavigatedInApp] = useState(false);
  const [hasForwardHistory, setHasForwardHistory] = useState(false);

  useEffect(
    () =>
      router.history.subscribe(({ action }) => {
        if (action.type === "PUSH") {
          setHasNavigatedInApp(true);
          setHasForwardHistory(false);
        } else if (
          action.type === "GO" ||
          action.type === "BACK" ||
          action.type === "FORWARD"
        ) {
          setHasNavigatedInApp(true);
        }
      }),
    [router],
  );

  const goBack = useCallback(() => {
    setHasForwardHistory(true);
    router.history.back();
  }, [router]);

  const goForward = useCallback(() => {
    router.history.forward();
  }, [router]);

  return {
    canGoBack: hasNavigatedInApp,
    canGoForward: hasForwardHistory,
    currentPath: location.href,
    goBack,
    goForward,
  };
};
